module.exports = __webpack_public_path__ + "assets/CircleInRhombus.d74520e0ab0e9a9aa7049915bedef161.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CircleInRhombus.gmt
// module id = 920
// module chunks = 0